import React, { useEffect, useRef, useState } from "react";
import "./dynamicForm.scss";
import editicon from "../../images/edit-icon.svg";
import closeIcon from "../../images/closeIcon.svg";
import checkIcon from "../../images/checkIcon.svg";
import disablecheckIcon from "../../images/diable-check.svg";
import grrencheckIcon from "../../images/greencheck.svg";
import TextInput from "../../commonfields/inputs/TextInput";
import JsonTooltip from "./JsonTooltip";
import Appservice from "../../services/appservice";
import { useParams } from "react-router-dom";
import { catchError } from "../../utils/Utils";
import { AxiosError } from "axios";
import SpinnerModel from "../../commonfields/inputs/SpinnerModel";
import { Input } from "reactstrap";
import { dropdownList } from "../../data/DropDownList";
import { IDropdownList } from "../../tsmodels/SharedModel";
import { DocumentStatusEnum } from "../../tsmodels/QuestionnaireModel";

interface FormField {
  fieldNo: any;
  verified: any;
  fieldtype: string;
  fieldName: string;
  section: any;
  coordinates: any;
  id: number;
  name: string;
  value: string;
  type: string;
  isEditing: boolean;
  unique_ids: any;
  sequenceNumber: number;
  page: number;
}

interface IDynamicFormProps {
  initialFields?: FormField[];
  onFieldClick?: Function;
  selectedField?: any;
  group: any;
  loader: boolean;
  status?: DocumentStatusEnum;
}

const DynamicForm = (props: IDynamicFormProps) => {
  const service = new Appservice();
  const params = useParams();

  // props
  const { loader, status } = props;

  // states
  const [fields, setFields] = useState<FormField[]>(props?.initialFields || []);

  // funcs - helpers
  const handleSelectingOptionChange = (id: number, field: any) => {
    // setSelectedFieldId(id);
    const payload = {
      ...field,
      fieldId: id,
      fieldNo: field.name,
      fieldName: field.fieldName,
      fieldType: field.type,
      section: field.section,
      verified: !field.verified,
      documentId: params.documentId,
    };
    if (payload.section && payload.fieldName) {
      handleSaveDocumentFeildsList(payload, "fromVerfication");
    }
  };

  const handleEdit = (fieldEdit: any) => {
    props?.onFieldClick && props?.onFieldClick(fieldEdit);
    setFields(
      fields.map((field) =>
        field.id === fieldEdit?.id ? { ...field, isEditing: true } : field
      )
    );
  };

  const handleSave = (id: number) => {
    setFields(
      fields.map((field) =>
        field.id === id ? { ...field, isEditing: false } : field
      )
    );
  };

  const handleCancel = (id: number) => {
    setFields(
      fields.map((field) =>
        field.id === id ? { ...field, isEditing: false } : field
      )
    );
  };

  const handleChange = (
    name: string,
    id: number,
    value: string,
    field: any
  ) => {
    setFields(
      fields.map((field) =>
        field.id === id ? { ...field, [name]: value } : field
      )
    );
    const payload = {
      ...field,
      fieldId: id,
      fieldNo: field?.name,
      fieldName: field?.fieldName,
      fieldType: field?.type,
      section: field?.section,
      verified: field?.verified || false,
      documentId: params.documentId,
      page: field.page,
      [name]: value,
    };
    if (payload.section && payload.fieldName) {
      handleSaveDocumentFeildsList(payload);
    }
  };

  const handleDropdownFieldChange = (id: number, value: string, field: any) => {
    setFields(
      fields.map((field) =>
        field.id === id ? { ...field, type: value } : field
      )
    );
    const payload = {
      ...field,
      fieldId: id,
      fieldNo: field?.name,
      fieldName: field?.fieldName,
      section: field?.section,
      verified: field?.verified || false,
      documentId: params.documentId,
      page: field.page,
      fieldType: value,
    };

    if (payload.section && payload.fieldName) {
      handleSaveDocumentFeildsList(payload);
    }
  };

  const onSaveJson = (payload: any, field: any) => {
    const _payload = {
      ...field,
      fieldType: field.type,
      fieldId: field.id,
      fieldNo: field.name,
      fieldName: field.fieldName,
      section: field.section,
      verified: field.verified,
      documentId: params.documentId,
      page: field.page,
      ...payload,
    };
    handleSaveDocumentFeildsList(_payload);
  };

  // funcs - api call
  const handleSaveDocumentFeildsList = (payload: any, cF = "") => {
    service
      .SaveDocumentExtractFields(payload)
      .then((res: any) => {
        cF &&
          cF === "fromVerfication" &&
          setFields(
            fields.map((field) =>
              field.id === payload.fieldId
                ? { ...field, verified: payload.verified }
                : field
            )
          );
        // setLoader(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {});
    ////
  };

  useEffect(() => {
    setFields(props?.initialFields || []);
  }, [props?.initialFields]);

  return (
    <div className="field-Form">
      <div className="dynamic-form">
        {loader ? (
          <SpinnerModel
            value={""}
            color={"primary"}
            size={""}
            type={"border"}
          />
        ) : null}

        {fields?.map((field) => (
          <div
            key={field.id}
            className="field-map"
            onClick={() => props?.onFieldClick && props?.onFieldClick(field)}
          >
            <div
              className={`field-row ${
                props?.selectedField?.id === field.id &&
                !field?.verified === true
                  ? "row-select"
                  : ""
              }${field?.verified === true ? "checked-Row" : ""}`}
            >
              <div className={`form-field ${field.isEditing ? "editing" : ""}`}>
                {props.group === "default" ? (
                  <div className="f_name">{field?.sequenceNumber ?? ''}</div>
                ) : (
                  ""
                )}

                <TextInput
                  className={`form-field ${
                    !(props.group === "default") ? "disable-inputFieldbox" : ""
                  } ${
                    props?.selectedField?.id === field.id &&
                    (field?.fieldName === undefined ||
                      field?.fieldName === null)
                      ? "error"
                      : ""
                  }`}
                  type="text"
                  value={field?.fieldName}
                  placeholder="Enter Field Name"
                  readOnly={
                    !(props.group === "default" || field.isEditing)!
                      ? true//<div></div>
                      : false
                  }
                  // error={true}
                  onBlur={(e: any) =>
                    handleChange("fieldName", field.id, e.target.value, field)
                  }
                />

                {props.group === "default" ? (
                  <TextInput
                    type="text"
                    value={field?.section}
                    placeholder="Enter Section Name"
                    className={
                      props?.selectedField?.id === field.id &&
                      (field?.section === undefined || field?.section === null)
                        ? "error"
                        : ""
                    }
                    // disabled={!field.isEditing}
                    onBlur={(e: any) =>
                      handleChange("section", field.id, e.target.value, field)
                    }
                  />
                ) : (
                  <></>
                )}

                {field.isEditing && !(props.group === "default") ? (
                  <div className="actions">
                    <button onClick={() => handleSave(field.id)}>
                      <img src={checkIcon} alt="save-icon" />
                    </button>
                    <button onClick={() => handleCancel(field.id)}>
                      <img src={closeIcon} alt="close-icon" />
                    </button>
                  </div>
                ) : (
                  <div
                    className="edit-icon-btn"
                    onClick={() => handleEdit(field)}
                  >
                    {!(props.group === "default") && field?.verified !== true ? (
                      <img
                        src={editicon}
                        alt="edit-icon"
                        className="edit-icon"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>

              <div className="dropdown">
                <div className="fieldType"></div>
                <div className="field-container">
                  <Input
                    className="field-type-select"
                    name="select"
                    type="select"
                    value={field?.type}
                    onChange={(e: any) =>
                      handleDropdownFieldChange(field.id, e.target.value, field)
                    }
                    //disabled={field?.verified}
                  >
                    {dropdownList?.map((p: IDropdownList, index) => (
                      <option key={index} value={p?.value}>
                        {p.value}
                      </option>
                    ))}
                  </Input>
                  <span className="type">Field Type</span>
                </div>
              </div>

                <JsonTooltip
                  disabled={field?.verified}
                  jsonData={{
                    fieldNo: field.name,
                    coordinates: field?.coordinates,
                  }}
                  isVisible={props?.selectedField?.id === field.id}
                  field={field}
                  onSaveJson={onSaveJson}
                />
            </div>

            {status === DocumentStatusEnum.VERIFIED ? (
              <div className="check">
                {field.verified ? (
                  <button
                    className="icon"
                    onClick={() => handleSelectingOptionChange(field.id, field)}
                  >
                    <img
                      src={grrencheckIcon}
                      alt="green-check-icon"
                      className="green-check"
                    />
                  </button>
                ) : (
                  <button
                    className="icon"
                    onClick={() => handleSelectingOptionChange(field.id, field)}
                  >
                    <img
                      src={disablecheckIcon}
                      alt="disable-check-icon"
                      className="check-icon"
                    />
                  </button>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DynamicForm;
